module.exports = __webpack_public_path__ + "img/Ent_Course_1.9d71fcda.jpg";